import React from "react";
import { Route } from "react-router-dom";
import Auth from "../components/Layout/Auth";
import Protected from "../components/Layout/Protected";
import SuspsenseFallBack from "../components/SuspsenseFallBack";
import { GenerateLayout } from "./generateLayout";
import { Iroute } from "./types";
import Public from "../components/Layout/Public";

export const generateRoute = ({
  path,
  Component,
  access,
  layout,
  perm,
}: Iroute) => {
  return (
    <Route
      key={`${path}`}
      element={
        access === "guest-only" ? (
          <Auth />
        ) : access === "loggedin-user" ? (
          <Protected />
        ) : (
          <Public />
        )
      }
    >
      {layout === undefined ? (
        <Route
          path={path}
          element={
            <React.Suspense fallback={<SuspsenseFallBack />}>
              <Component />
            </React.Suspense>
          }
        />
      ) : null}
      {layout ? (
        <Route element={<GenerateLayout layout={layout} perm={perm} />}>
          <Route
            path={path}
            element={
              <React.Suspense fallback={<SuspsenseFallBack />}>
                <Component />
              </React.Suspense>
            }
          />
        </Route>
      ) : null}
    </Route>
  );
};
